import pf from "platform";
if ((pf.name === "IE") && (parseInt(pf.version, 10) < 11)) {
    window.location.href = "./js.html";
}